import { Controller } from "@hotwired/stimulus";
import Glide from "@glidejs/glide";

export default class extends Controller {
  connect() {
    const slides = this.element.querySelectorAll(".glide__slides > *");
    if (slides.length < 3) {
      return;
    }

    this.slider = new Glide(this.element.querySelector(".glide"), {
      type: "carousel",
      perView: 3,
      rewind: false,
      bound: true,
      gap: 30,
      breakpoints: {
        1200: {
          perView: 2,
        },
        769: {
          perView: 1,
          peek: 40,
          gap: 16,
        },
        // 1000: {
        //   perView: 1,
        //   peek: 40,
        // },
      },
    });

    this.slider.on("run", () => {
      document.body.classList.add("swiping");
    });

    this.slider.on("run.after", () => {
      document.body.classList.remove("swiping");
    });

    this.slider.mount();
  }

  // maybeClick(evt) {
  //   if (this.swiping) {
  //     evt.preventDefault();
  //     evt.stopPropagation();
  //     return false;
  //   }

  //   return true;
  // }

  next() {
    this.slider.go(">");
  }

  prev() {
    this.slider.go("<");
  }

  disconnect() {
    this.slider.destroy();
  }
}
